import { FunctionComponent } from 'react';
import { t } from '@/utils/i18n';
import { Info } from '@/components/common/icons/Info';
import './StickerHint.scss';

interface StickerHintProps {
  height?: number;
}

export const StickerHint: FunctionComponent<StickerHintProps> = ({ height }) => {
  return (
    <div className="sticker-design-hint" style={{ minHeight: height }}>
      <Info className="sticker-design-hint__icon" />
      <span>{t('sticker.oneDesign.hint')}</span>
    </div>
  );
};
